import { Button, LinearProgress, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import {
  ResourceCard,
  ResourceCardContainer,
  ResourceCardHeader,
  ResourceCardTitle,
} from '@/components/shared/resource-card';
import type { EduplayCourse } from '@/data/eduplay/interfaces';
import { useGenerateCertificate } from '@/packages/eduplay/hooks';
import { getEduplayImageUrl } from '@/utils/get-image-url';

const CardAction = ({ course }: { course: EduplayCourse }) => {
  const navigate = useNavigate();
  const { viewCertificate, loadingCertificate } = useGenerateCertificate(
    course.cursos_horarios_id
  );

  if (course.is_completed) {
    return (
      <>
        <Button
          variant="outlined"
          onClick={viewCertificate}
          disabled={loadingCertificate}
          loading={loadingCertificate}
        >
          {loadingCertificate ? 'Gerando certificado...' : 'Ver certificado'}
        </Button>
        <Button
          onClick={() =>
            navigate(`/cursos/${course.curso_horario.curso_detalhe_id}`)
          }
        >
          Informações do curso
        </Button>
      </>
    );
  }

  return (
    <Button component="span" variant="outlined">
      Continuar curso
    </Button>
  );
};

export const EduplayCourseCard = ({ course }: { course: EduplayCourse }) => {
  const imageUrl = getEduplayImageUrl(
    course.curso_horario.curso_detalhe.curso.imagem
  );
  const progress = course?.progresso ?? 0;
  const isCompleted = course?.is_completed;
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/meu-aprendizado/curso/${course.cursos_horarios_id}`);
  };

  const href = isCompleted
    ? undefined
    : `/meu-aprendizado/curso/${course.cursos_horarios_id}`;

  return (
    <ResourceCard onClick={isCompleted ? undefined : handleClick} href={href}>
      <ResourceCardHeader
        image={{
          type: 'image',
          src: imageUrl,
          alt: '',
        }}
      />

      <ResourceCardContainer>
        <ResourceCardTitle>
          {course.curso_horario.curso_detalhe.name}
        </ResourceCardTitle>
        <Typography variant="body2">Progresso {progress}%</Typography>
        <LinearProgress value={progress} variant="determinate" />
        <CardAction course={course} />
      </ResourceCardContainer>
    </ResourceCard>
  );
};
